import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Box, RadioButton } from '@chargify/custom-ui-components';
import { OptionsWrapper } from '../../../../components/RadioOptions';
import { RequiredStar } from './ChurnReasonCodes.styles';
import { ChurnReason } from '../../../../models';

export type ChurnReasonCodesProps = {
  items: ChurnReason[];
  onChange: (value: string) => void;
  selectedValue: string;
};
export const ChurnReasonCodes = ({
  items,
  onChange,
  selectedValue,
}: ChurnReasonCodesProps) => {
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <Box marginBottom={6}>
      <Box marginBottom={5}>
        <BodyText>
          {t('cancel_subscription.what_is_the_reason')}{' '}
          <RequiredStar>*</RequiredStar>
        </BodyText>
      </Box>
      <OptionsWrapper>
        {items
          .sort((a, b) => a.position - b.position)
          .map(({ id, code, description }) => (
            <RadioButton
              key={id}
              label={description}
              value={code}
              onValueChange={onChange}
              isSelected={code === selectedValue}
            />
          ))}
      </OptionsWrapper>
    </Box>
  );
};
